/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createEndorsingInstitutionRequest } from '../models/api_createEndorsingInstitutionRequest';
import type { api_createEndorsingInstitutionResponse } from '../models/api_createEndorsingInstitutionResponse';
import type { api_getEndorsingInstitutionResponse } from '../models/api_getEndorsingInstitutionResponse';
import type { db_ListEndorsingInstitutionsRow } from '../models/db_ListEndorsingInstitutionsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EndorsingInstitutions {
    /**
     * Get a list of endorsing institutions
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListEndorsingInstitutionsRow OK
     * @throws ApiError
     */
    public static listEndorsingInstitutions(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListEndorsingInstitutionsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/endorsing-institutions',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an endorsing institution
     * @param body Endorsing institution details
     * @returns api_createEndorsingInstitutionResponse Created
     * @throws ApiError
     */
    public static createEndorsingInstitution(
        body: api_createEndorsingInstitutionRequest,
    ): CancelablePromise<api_createEndorsingInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/endorsing-institutions',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an endorsing institution record
     * @param id Endorsing institution ID
     * @returns api_getEndorsingInstitutionResponse OK
     * @throws ApiError
     */
    public static getEndorsingInstitution(
        id: number,
    ): CancelablePromise<api_getEndorsingInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/endorsing-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete an endorsing institution
     * @param id EndorsingInstitution ID
     * @returns void
     * @throws ApiError
     */
    public static deleteEndorsingInstitution(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/endorsing-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an endorsing institution
     * @param id EndorsingInstitution ID
     * @param body EndorsingInstitution details
     * @returns void
     * @throws ApiError
     */
    public static updateEndorsingInstitution(
        id: number,
        body: api_createEndorsingInstitutionRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/endorsing-institutions/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
